export const merchantCompanyGetters = {
  allMerchantCompanys: (state) => state.allMerchantCompanys,
  selectedMerchantCompany: (state) => state.selectedMerchantCompany,
};
